export enum CustomRulesVersionStatus {
  Active = 'Active',
  Draft = 'Draft',
  Archived = 'Archived',
  Rejected = 'Rejected',
}
